import { ValidatorFn, Validators } from "@angular/forms";
import { CommonArgs, InputBase } from "common/form/input/types/input-base";

export class FloatInput extends InputBase<number> {
	min?: number;
	max?: number;

	constructor(args: FloatArgs) {
		super({
			key: args.key,
			value: args.value,
			type: "number",
			inputFieldType: "number",
			required: args.required,
			translateKey: args.translateKey,
			untranslatableName: args.untranslatableName,
			readonly: args.readonly,
			hidden: args.hidden,
			isCascading: args.isCascading,
		});
		this.min = args.min === null ? undefined : args.min;
		this.max = args.max === null ? undefined : args.max;

		super.addValidator(this.validateFloatPattern());
		if (this.min !== undefined && this.min !== null) {
			super.addValidator(Validators.min(this.min));
		}
		if (this.max !== undefined && this.max !== null) {
			super.addValidator(Validators.max(this.max));
		}
	}

	validateFloatPattern(): ValidatorFn {
		return (control) => {
			if (!control.value) {
				return null;
			}

			const regExp = new RegExp("^-?\\d+(\\.{1}\\d+)?$");
			return regExp.test(control.value)
				? null
				: {
						integer: {
							valid: false,
						},
				  };
		};
	}
}

export class FloatArgs extends CommonArgs<number> {
	min?: number | null;
	max?: number | null;
}
